export function extractErrorMessage(error) {
  if (!error.response) {
    return "ارتباط با سرور برقرار نشد.";
  }

  const data = error.response.data;

  if (!data) {
    return "خطای ناشناخته‌ای رخ داده است.";
  }

  // خطاهای معمول
  if (data.detail) return data.detail;
  if (data.error) return data.error;
  if (data.message) return data.message;

  // خطاهای validation (مثلا DRF یا Laravel)
  if (data.errors) {
    const messages = [];

    Object.keys(data.errors).forEach((field) => {
      const fieldErrors = data.errors[field];
      if (Array.isArray(fieldErrors)) {
        messages.push(...fieldErrors);
      } else {
        messages.push(fieldErrors);
      }
    });

    return messages.join(" | ");
  }

  // اگر کل response یک string باشد
  if (typeof data === "string") {
    return data;
  }

  return "خطایی در سمت سرور رخ داده است.";
}
